import { render, staticRenderFns } from "./ModalAccessDetail.vue?vue&type=template&id=2f46506d&scoped=true"
import script from "./ModalAccessDetail.vue?vue&type=script&lang=js"
export * from "./ModalAccessDetail.vue?vue&type=script&lang=js"
import style0 from "./ModalAccessDetail.vue?vue&type=style&index=0&id=2f46506d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f46506d",
  null
  
)

export default component.exports